import {
  Box,
  Grid,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Button from "../../common/Button";
import PageBackButton from "../../common/PageBackButton";
import CustomTextField from "../../common/CustomTextField";
import {
  OrderInfo,
  OrderReturn,
  addProductReturn,
  getOrderItemsByOrderId,
  useOrderSlice,
} from "../../../redux/slice/order/OrderSlice";
import { useForm, useWatch,Controller } from "react-hook-form";
import {
  Cancel,
  ClassOutlined,
  PersonOutlined,
} from "@mui/icons-material";
import Dropzone from "../../common/Dropzone";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDatePicker from "../../common/CustomDatePicker";
import { tokens } from "../../../theme";
import React, { useEffect, useMemo, useState } from "react";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import moment from "moment";
import SignaturePad, {
  SignatureData,
} from "../../common/signature/SignaturePad";
import {
  SingleAlertInfo,
  hideSingleAlert,
  setSingleAlertObj,
} from "../../../redux/slice/commonSlice";
import { OrderItemRow } from "./TissueTracking";
import CustomCheckbox from "../../common/CustomCheckBox";
import dayjs, { Dayjs } from "dayjs";
import {
  CodeTable,
  fetchAllCodeTablesValues,
  getCodeTableValuesByTableName,
  useCodetablesSlice,
} from "../../../redux/slice/codetableSlice";
import OptionsPopup, {
  OptionPopupObjectProps,
} from "../../common/OptionsPopup";
import { selectIsValueFoundInToken, useAuthSlice } from "../../../redux/slice/authSlice";
import { fullName, sortNames } from "../../../utils/Utility";
import CustomHelpMessage from "../../common/CustomHelpMessage";
import CustomRadioButton from "../../common/CustomRadioButton";
import { useNavigation } from "../../../hooks/useNavigation";
import SigantureSubmitPopup from "./SignatureSubmitPopup";
import { CAN_ACCESS_APPLICATION, ORDER_ACTIONS, ORDER_AVAILABILITY } from "../../../constants/applicationConstants";
import useToken from "../../../hooks/useToken";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { SectionHeader } from "../../ui/ContentSection";
import { useModalStyles } from "../../common/useModalStyles";

interface ExtendedFile extends File {
  documentId?: string;
}

interface Attachment {
  documentName: string;
  content: string;
  fileType: string;
}

interface ReturnOrderInfo {
  orderId: number;
  productId: number;
  returnReason: string;
  otherReturnReason: string;
  returnDate: string;
  signature: string;
  name: string;
  orderItems: {}[];
  productNotDamaged: boolean;
  productNotTransfer: boolean;
  productStoredInRecommendedEnv: boolean;
  isShippingLabel:boolean; 
  returnTrackingInfo: {
    returnCarrier: string;
    returnTracking: string;
  };

  attachmentBarcodeSticker: {
    documentName: string;
    content: string;
    fileType: string;
  }[];

  attachmentProductBoxPictures: {
    documentName: string;
    content: string;
    fileType: string;
  }[];

  serialNumbers?: string[],
}

interface FormattedOrderItem {
  orderItemId: number;
  serialNumber?: any;
}

interface ExtendedReturnOrder extends ReturnOrderInfo {
  checkbox: string[];
  selectAll: boolean;
}


  

const Returns = () => {
  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    setError,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm<ExtendedReturnOrder>({
    defaultValues: {
      orderId: 0,
      productId: 0,
      returnReason: "",
      otherReturnReason: "",
      returnDate: dayjs(new Date()).format("MM/DD/YYYY"),
      signature: "",
      name: "",
      orderItems: [],
      productNotDamaged: false,
      productNotTransfer: false,
      productStoredInRecommendedEnv: false,
      isShippingLabel:false,
      returnTrackingInfo: {
        returnCarrier: "",
        returnTracking: "",
      },
      attachmentBarcodeSticker: [],
      attachmentProductBoxPictures: [],
    },
  });

  const { navigate } = useNavigation();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { userInfo } = useAuthSlice();
  const isTokenValueAvailable = useToken();
  const canOverrideReturn = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.MANAGE_RE_RETURN)(state));
  const {
    tokens: mTokens,
    isDark: isDarkModal,
    dropdownWrapSx,
    inputFieldSx,
    primaryBtnSx,
    cancelBtnSx,
  } = useModalStyles();
  const cardSx = {
    borderRadius: "16px",
    border: `1px solid ${mTokens.border}`,
    backgroundColor: mTokens.bg,
    backgroundImage: "none",
    overflow: "hidden",
    boxShadow: isDarkModal ? "0 10px 20px rgba(0,0,0,0.1)" : "none",
  };

  const [orderInfo, setOrderInfo] = useState<OrderInfo>();
  const { orderItemsListInfo } = useOrderSlice();
  const [checkedItems, setCheckedItems] = useState<{ [key: number]: boolean }>(
    {}
  );
  const [ checkedList, setCheckedList ] = useState<number[]>([]);
  const [formattedOrderItems, setFormattedOrderItems] = useState<
    FormattedOrderItem[]
  >([]);
  const { allCodeTablesValuesMap } = useCodetablesSlice();
  const [isAllAppliedOrReturned, setIsAllAppliedOrReturned] = useState(true);
  const [showOptionPopup, setShowOptionsPopup] =
    useState<OptionPopupObjectProps>({ message: "", show: false });
  const today = dayjs().toDate(); // Initialize today's date using dayjs
  const [showOtherReturnOption, setShowOtherReturnOption] = useState(false);
  const [formInteracted, setFormInteracted] = useState(false);
  const [selectedRow, setSelectedRow] = useState<OrderItemRow[] | []>([]); 


  const [selectedOption, setSelectedOption] = useState<string>("");
  const [error, setErrors] = useState(false);
  const [showSignatureSubmitPopup, setShowSignatureSubmitPopup] = useState<boolean>(false);
  const [selectedUserData, setSelectedUserData] = useState<any>(null);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // CS-1426

  const handleOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(e.target.value);
    setErrors(false);
  };


  
  // Mount
  useEffect(() => {
    const orderDetails: OrderInfo = location?.state?.orderDetails;
    setOrderInfo(orderDetails);
    dispatch(getOrderItemsByOrderId(orderDetails.orderId));
    setValue("orderId", orderDetails.orderId);
    setValue("productId", orderDetails.productId);
  }, []);

  const handleSignatureChange = (data: SignatureData) => {
    setValue("signature", data.signature);
    setValue("name", data.typedText);
  };

  const onSubmit = async (data: ReturnOrderInfo) => {
   

    if (isAllAppliedOrReturned) {
      let warningObj: SingleAlertInfo = {
        message: "Order items aren't available to Return.",
        alertType: "warning",
      };
      dispatch(setSingleAlertObj(warningObj));
    } else if (
      !(
        data.productNotDamaged &&
        data.productNotTransfer &&
        data.productStoredInRecommendedEnv
      )
    ) {
      let warningObj: SingleAlertInfo = {
        message:
          "Please select all the statements regarding the return product status.",
        alertType: "warning",
      };
      dispatch(setSingleAlertObj(warningObj));
    } else {
      if (formattedOrderItems.length === 0 ) {
        
        let errObj: SingleAlertInfo = {
          message: "Please select at least one Order item.",
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errObj));
      }
      else {
        clearErrors("attachmentBarcodeSticker");
        clearErrors("attachmentProductBoxPictures");
        clearErrors("checkbox");
        clearErrors("selectAll");
        setSelectedUserData(fullName(null, userInfo.firstName, userInfo.middleName, userInfo.lastName))
        setShowSignatureSubmitPopup(true);
      }
    }
  };

  const returnOrder = async (data: any) => {
    const returnOrderObject: OrderReturn = {
      orderId: parseInt(data.orderId),
      productId: parseInt(data.productId),
      returnReason: data.returnReason,
      otherReturnReason: data.otherReturnReason,
      isShippingLabel:selectedOption==="yes"?true:false,
      returnTrackingInfo: data.returnTrackingInfo,
      returnDate: data.returnDate
        ? moment(data.returnDate?.toString())?.format("MM/DD/YYYY")
        : "",
      productNotDamaged: data.productNotDamaged,
      productNotTransfer: data.productNotTransfer,
     
      productStoredInRecommendedEnv: data.productStoredInRecommendedEnv,
      signature: data.signature,
      name: data.name,
      orderItems: formattedOrderItems,
      attachmentBarcodeSticker: data.attachmentBarcodeSticker,
      attachmentProductBoxPictures: data.attachmentProductBoxPictures,
      additionalContext: data.additionalContext
      
    };
    const response = await dispatch(addProductReturn(returnOrderObject));
    if (response.payload.message === "SUCCESS") {
      let successObj: SingleAlertInfo = {
        // message: `Order ${orderInfo?.orderNumber} has submitted return request successfully.`,
        message : `Return request for Order ${orderInfo?.orderNumber} has been submitted.`,
        alertType: "success",
      };
      dispatch(setSingleAlertObj(successObj));
      navigate(-1);
    }
  };

  const cancelOptionPopup = () => {
    setShowOptionsPopup({ message: "", show: false });
  };

  const orderItemRow: OrderItemRow[] = useMemo(() => {
    let orderItems: OrderItemRow[] = [];

    if (orderItemsListInfo) {
      orderItems = orderItemsListInfo.map((item) => {
        //@ts-ignore
        setValue(`serialNumbers.serialNumber${item.orderItemId}`,item.serialNumber);
        return {
          select: <CustomCheckbox control={control} name="select" />,
          orderItemId: item.orderItemId,
          serialNumber: item.serialNumber,
          size: item.size,
          tissueTrackingId: item.tissueTrackingId,
          productReturnStatus: item.productReturnStatus,
          productReturnId: item.productReturnId,
          units: item.units
        };
      })
      .sort((a, b) => a.units - b.units);
    }

    return orderItems;
  }, [orderItemsListInfo]);

  // CS-1164 START
  const orderItemStatus = (row: OrderItemRow) => {
    if (row?.tissueTrackingId) {
      return "Applied";
    } else if (row?.productReturnId) {
      // return `Returned`;
      if (row.productReturnStatus === ORDER_AVAILABILITY.RETURN_INITIATED) {
        return  `Return Initiated`;
      } else if (row.productReturnStatus === ORDER_AVAILABILITY.RETURN_PENDING) {
        return  `Return Pending`;
      } else if (row.productReturnStatus === ORDER_AVAILABILITY.RETURNED) {
        return `Returned`;
      } else if (row.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED) {
        return `Available(Return Rejected)`;
      }
    }
    return "Available";
  };
  // CS-1164 END

  const checkSerialNumberPresent = (row: OrderItemRow) => {
    if(checkedList.includes(row.orderItemId)) {
      return false;
    } 
    return true;
  };

  const handleFaceSheetChange = async (uploadedFiles: ExtendedFile[]) => {
    const readFileAsBase64 = (file: File): Promise<string> => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    };

    const attachments: Attachment[] = await Promise.all(
      uploadedFiles.map(async (file) => {
        const base64Content = await readFileAsBase64(file);
        return {
          documentName: file.name,
          content: base64Content.split(",")[1],
          fileType: file.type,
        };
      })
    );

    setValue("attachmentBarcodeSticker", attachments);
  };

  const handleProductBoxPicturesChange = async (uploadedFiles: ExtendedFile[]) => {
    const readFileAsBase64 = (file: File): Promise<string> => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    };

    const attachments: Attachment[] = await Promise.all(
      uploadedFiles.map(async (file) => {
        const base64Content = await readFileAsBase64(file);
        return {
          documentName: file.name,
          content: base64Content.split(",")[1],
          fileType: file.type,
        };
      })
    );

    setValue("attachmentProductBoxPictures", attachments);
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, row: OrderItemRow) => {
    const { checked } = e.target;
    if (checked) {
      row && setCheckedList(prevValues => {
        const newValues: number[] = [...prevValues];
        newValues.push(row.orderItemId);
        return newValues;
      });

      setSelectedRow((data)=>{
        let selectedOrderItemRow: OrderItemRow[]  = [];

        data?.map((itemRow)=>selectedOrderItemRow.push(itemRow));
        selectedOrderItemRow.push(row);
        return selectedOrderItemRow;
      })
    } else {
      setCheckedList(checkedList.filter(item => item !== row.orderItemId));

      setSelectedRow((data)=>{
        return data?.filter((itemRow)=> itemRow.orderItemId !== row.orderItemId) || [];
      })
      setValue("selectAll", false);
    }
  };

  const isCheckBoxDisable = (row: OrderItemRow) => {
    if (row?.tissueTrackingId) return true;
    if (row?.productReturnId) {
      if (row.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED && canOverrideReturn) {
        return false;
      }
      return true;
    }
    return false;
  };

  useEffect(() => {
    const newFormattedOrderItems: FormattedOrderItem[] = checkedList.map(orderItemId => {
      return {
        orderItemId: orderItemId,
        //@ts-ignore
        serialNumber: getValues(`serialNumbers.serialNumber${orderItemId}`)
      }
    });
    setFormattedOrderItems(newFormattedOrderItems);
  }, [checkedList, getValues()]);

  useEffect(() => {
    if (orderItemsListInfo) {
      const isAllItemAppliedOrReturned = orderItemsListInfo.every(
        (item: { productReturnId: any; tissueTrackingId: any; productReturnStatus: any; }) => {
          const hasReturn = !!item.productReturnId;
          const isRejected = item.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED;
          const canSelectRejected = isRejected && canOverrideReturn;
          return (hasReturn && !canSelectRejected) || !!item.tissueTrackingId;
        }
      );
      setIsAllAppliedOrReturned(!!isAllItemAppliedOrReturned);
    }
  }, [orderItemsListInfo, canOverrideReturn]);

  const returnReasonList = useMemo(() => {
    let codeTableList: CodeTable[] = [];

    if (allCodeTablesValuesMap) {
      codeTableList = getCodeTableValuesByTableName(
        allCodeTablesValuesMap,
        "OrderReturn"
      );
    }
    const sortedProductList: CodeTable[] = sortNames(
      codeTableList,
      "displayValue"
    );

    if (sortedProductList) {
      let options = sortedProductList.map((option) => ({
        label: option.displayValue,
        value: option.displayValue,
      }));
      // used to set other option at the bottom of the list
      const otherOptionIndex = options.findIndex(
        (option) => option.value.toLowerCase() === "other"
      );
      const [otherOption] = options.splice(otherOptionIndex, 1);
      options.push(otherOption);
      return options;
    }
    return [];
  }, [allCodeTablesValuesMap]);

  const onChangeReturnReasonList = (event: any) => {
    if (event) {
      if (event && event.label === "Other") {
        setShowOtherReturnOption(true);
        setValue("returnReason", event.value);
      } else {
        setShowOtherReturnOption(false);
        setValue("returnReason", event && event.value);
      }
    }else {
       setShowOtherReturnOption(false);
    }
  };

  const carrierOptions = useMemo(() => {
    let carriers: CodeTable[] = [];
    if (allCodeTablesValuesMap) {
      carriers = getCodeTableValuesByTableName(
        allCodeTablesValuesMap,
        "Carrier"
      );
    }
    if (!carriers || carriers.length === 0) {
      dispatch(fetchAllCodeTablesValues());
    }
    let options: { label: string; value: any }[] = [];
    carriers?.map((option) => {
      options.push({ label: option.displayValue, value: option.displayValue });
    });
    return options;
  }, [allCodeTablesValuesMap]);

  const hasSerialNumberPresent = (row: OrderItemRow[]) => {
    let hasNoSerialNumber = false;

    row?.map((element: OrderItemRow) => {
      if (element.serialNumber === "" || element.serialNumber === null) {
        hasNoSerialNumber = true;
      }
    })

    return hasNoSerialNumber;
  };

  const onError = (_errors: any, e: any) => {

    const returnCarrier = getValues('returnTrackingInfo.returnCarrier');
    const returnTracking = getValues('returnTrackingInfo.returnTracking');

   

    const { attachmentBarcodeSticker, attachmentProductBoxPictures } = getValues();
    let hasError = false;

    if (checkedList?.length <= 0) {
      let errorObj: SingleAlertInfo = {
        message: "Please select at least one Order item.",
        alertType: "error"
      };
      dispatch(setSingleAlertObj(errorObj));
      hasError = true;
      cancelOptionPopup();
    } 
    else if ((selectedRow.length === 0 || hasSerialNumberPresent(selectedRow)) && attachmentBarcodeSticker?.length <= 0) {
      let errorObj: SingleAlertInfo = {
        message: "Barcode Sticker Attachment is required.",
        alertType: "error"
      };
      dispatch(setSingleAlertObj(errorObj));
      hasError = true;
      cancelOptionPopup();
      clearErrors("checkbox");
      clearErrors("selectAll");
    } 
    else if (attachmentProductBoxPictures?.length <= 0) {
      let errorObj: SingleAlertInfo = {
        message: "Pictures of the box that contains the product(s) is required.",
        alertType: "error"
      };
      dispatch(setSingleAlertObj(errorObj));
      hasError = true;
      cancelOptionPopup();
      clearErrors("checkbox");
      clearErrors("selectAll");
      clearErrors("attachmentBarcodeSticker");
    }
    else if (getValues("returnReason") === "") {
      let errorObj: SingleAlertInfo = { 
        message: "Please select a return reason.", 
        alertType: "error" 
      };
      dispatch(setSingleAlertObj(errorObj));
      hasError = true;
      dispatch(hideSingleAlert());
      clearErrors("attachmentBarcodeSticker");
      clearErrors("attachmentProductBoxPictures");
      clearErrors("checkbox");
      clearErrors("selectAll");

    }
    
      // cs-549 task changes error handle 
    else if (selectedOption === "yes") {
      if (returnCarrier === "" && returnTracking === "") {
       
        let errObj: SingleAlertInfo = {
          message: "Please select Carrier and Shipping Tracking is required.",
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errObj));
        hasError = true;
        dispatch(hideSingleAlert());
      } else if (returnCarrier === "") {
        
        let errObj: SingleAlertInfo = {
          message: "Please select Carrier.",
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errObj));
        hasError = true;
        dispatch(hideSingleAlert());
      } else if (returnTracking === "") {
       
        let errObj: SingleAlertInfo = {
          message: "Shipping Tracking is required",
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errObj));
        hasError = true;
        dispatch(hideSingleAlert());
      }
      clearErrors("attachmentBarcodeSticker");
      clearErrors("attachmentProductBoxPictures");
      clearErrors("checkbox");
      clearErrors("selectAll");
    }
    
    else {
      const serialNumbers = getValues("serialNumbers");
      let isNotEmpty = false;
      const hasBarcodeSticker = getValues("attachmentBarcodeSticker").length > 0 && getValues("attachmentProductBoxPictures").length > 0;

      checkedList?.map(itemId => {
        //@ts-ignore
        if (serialNumbers[`serialNumber${itemId}`]) {
          isNotEmpty = true;
        }
        //@ts-ignore
        else if (!serialNumbers[`serialNumber${itemId}`] && hasBarcodeSticker) {
          isNotEmpty = true;
        }
      });

      if (isNotEmpty) {
        clearErrors("attachmentBarcodeSticker");
        clearErrors("attachmentProductBoxPictures");
        clearErrors("checkbox");
        clearErrors("selectAll");
      }
    }
 
    if (Object.keys(errors).length > 0 || hasError) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      const data = getValues();
      onSubmit(data);
    }
  };
   

  const signaturePadValidations = {
    name: {
      required: "Name is required.",
    },
    signature: {
      required: "Signature is required.",
    },
  };

  const handleSelectAllCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    if (checked) {
      const selectList: number[] = [];
      orderItemRow?.forEach(row => {
        const isRejected = row.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED;
        const allowRejected = isRejected && canOverrideReturn;
        if ((row?.tissueTrackingId === null && (row?.productReturnId === null || allowRejected))) {
          selectList.push(row.orderItemId);
          //@ts-ignore
          setValue(`checkbox.order${row.orderItemId}`, true);
  
          setSelectedRow((prevSelectedRows) => {
            if (!prevSelectedRows?.some(itemRow => itemRow.orderItemId === row.orderItemId)) {
              return [...prevSelectedRows, row];
            }
            return prevSelectedRows;
          });
        }
      });
  
      setCheckedList(selectList);

    } else {
      setCheckedList([]);
      orderItemRow?.forEach(row => {
        const isRejected = row.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED;
        const allowRejected = isRejected && canOverrideReturn;
        if ((row?.tissueTrackingId === null && (row?.productReturnId === null || allowRejected))) {
          //@ts-ignore
          setValue(`checkbox.order${row.orderItemId}`, false);

          setSelectedRow((prevSelectedRows) => {
            return prevSelectedRows?.filter(itemRow => itemRow.orderItemId !== row.orderItemId) || [];
          });
        }
      });
    }
  };

  const handleSerialNumberChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, row: OrderItemRow) => {
    let existingRow = selectedRow.find(item => item.orderItemId === row.orderItemId);

    if (existingRow && existingRow !== null) {
      let updatedRow: OrderItemRow = {
        ...existingRow,
        serialNumber: e.target.value,
      };

      setSelectedRow((prevRows) => {
        let otherRows = prevRows?.filter((item) => item.orderItemId !== row.orderItemId) || [];
        return [...otherRows, updatedRow];
      });
    }
    // Trigger validation on change
    trigger(`serialNumbers.serialNumber${row.orderItemId}` as any);
  };

  const handleSignatureData = async (data: any) => {
    setValue("signature", data.providerInformation.signature);
    setValue("name", data.providerInformation.typedText);

    // Wait for React Hook Form to update state
    await trigger();

    // Get the updated form values
    const updatedData = getValues();

    setShowOptionsPopup({
      message: "Do you really want to return the order? ",
      show: true,
      variant: "confirm",
      buttons: [
        {
          name: "Confirm",
          color: "primary",
          onClick: () => returnOrder(updatedData),
        },
        { name: "Cancel", color: "secondary", onClick: cancelOptionPopup },
      ],
    });
  }

  useEffect(() => {
    if (watch("attachmentProductBoxPictures")?.length > 0) {
      clearErrors("attachmentProductBoxPictures");
    }
  }, [clearErrors, watch("attachmentProductBoxPictures")])

  const FieldLabel = ({ label, required = false }: { label: string; required?: boolean }) => (
    <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: mTokens.textSecondary, mb: 0.9, display: "flex", alignItems: "center", gap: 0.4 }}>
      {label}
      {required && (
        <Box component="span" sx={{ color: mTokens.accent }}>
          *
        </Box>
      )}
    </Typography>
  );

  const InfoRow = ({ label, value }: { label: string; value?: React.ReactNode }) => (
    <Box display="flex" alignItems="center" py={1.15} sx={{ borderBottom: `1px solid ${mTokens.border}`, "&:last-child": { borderBottom: "none" } }}>
      <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary, width: "45%", flexShrink: 0 }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 600, flex: 1 }} component="div">
        {value ?? "—"}
      </Typography>
    </Box>
  );

  const colHeaderSx = {
    fontSize: "0.68rem",
    fontWeight: 700,
    color: mTokens.textSecondary,
    textTransform: "uppercase" as const,
    letterSpacing: "0.08em",
  };
  const colBodySx = { fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 500 };

  // CS-1426 - Start
  // Card renderer for mobile view
  const renderOrderItemCard = (row: OrderItemRow) => (
    <Box
      key={row.orderItemId}
      sx={{
        mb: 1.5,
        p: 1.8,
        borderRadius: "12px",
        border: `1px solid ${mTokens.border}`,
        backgroundColor: mTokens.headerFooterBg,
      }}
    >
      <Box display="flex" alignItems="flex-start" gap={1.2}>
        <Box pt={0.3}>
          <CustomCheckbox
            onChange={(e) => handleCheckboxChange(e, row)}
            isDisabled={isCheckBoxDisable(row)}
            control={control}
            controllerName={`checkbox.order${row.orderItemId}`}
            rules={!isAllAppliedOrReturned ? { required: true } : {}}
          />
        </Box>
        <Box flex={1} minWidth={0}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.8}>
            <Typography sx={{ fontSize: "0.95rem", fontWeight: 700, color: mTokens.textPrimary }}>
              {row.size}
            </Typography>
            <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: mTokens.textSecondary }}>
              {orderItemStatus(row)}
            </Typography>
          </Box>
          <FieldLabel label="Serial Number" />
          <Box sx={inputFieldSx()}>
            <CustomTextField
              controllerName={`serialNumbers.serialNumber${row.orderItemId}`}
              control={control}
              label=""
              size="small"
              //@ts-ignore
              isDisabled={checkSerialNumberPresent(row)}
              onChange={(e) => handleSerialNumberChange(e, row)}
              onBlur={() => trigger(`serialNumbers.serialNumber${row.orderItemId}` as any)}
              rules={{ maxLength: { value: 50, message: "Serial Number cannot exceed 50 characters" } }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
  // CS-1426 - End

  return (
    <Box
      sx={{
        mx: { xs: "10px", sm: "20px" },
        mt: "12px",
        pb: "72px",
      }}
    >
      {showOptionPopup.show && (
        <OptionsPopup
          open={showOptionPopup.show}
          onClose={() => setShowOptionsPopup({ message: "", show: false })}
          variant={showOptionPopup.variant}
          message={<>{showOptionPopup.message}</>}
          buttons={showOptionPopup.buttons}
          title={showOptionPopup.title}
          obj={showOptionPopup.obj}
        />
      )}
      {showSignatureSubmitPopup && 
      <SigantureSubmitPopup
        open={showSignatureSubmitPopup}
        onClose={() => { setShowSignatureSubmitPopup(false); }}
        addProductItem={() => { }}
        productItemDetails={{}}
        isEdit={false}
        addSignature={handleSignatureData}
        from="Return"
        authorizedSigner={false}
        authorizedSignerName={selectedUserData}
      />}

      <Box mb={2} display="flex" alignItems="flex-start" gap={1.5}>
        <PageBackButton tooltip={null} />
        <Box data-testid="header">
          <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: mTokens.textSecondary, textTransform: "uppercase", letterSpacing: "0.12em", mb: 0.3 }}>
            Orders / Returns
          </Typography>
          <Typography component="h1" sx={{ fontSize: "1.6rem", fontWeight: 800, color: mTokens.textPrimary, lineHeight: 1.1 }}>
            Returns
          </Typography>
          <Typography sx={{ fontSize: "0.78rem", color: mTokens.textSecondary, mt: 0.4 }}>
            This will create a return request.
          </Typography>
        </Box>
      </Box>

      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1.4fr 1fr" }, gap: 2, alignItems: "flex-start" }}>
          {/* Left: form */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, order: { xs: 2, md: 1 } }}>

            {/* Card 1: Return Details */}
            <Box sx={cardSx}>
              <Box sx={{ px: 3.2, pt: 2.2, pb: 3.2 }}>
                <Grid container spacing={2.5}>
                  {/* <Grid item md={3} xs={12}>
                    <Box display="flex" alignItems="center">
                        <Typography component="span" fontWeight="bold">
                          Return Date:
                        </Typography>
                        <Box ml={2}>
                          <CustomDatePicker
                            control={control}
                            controllerName="returnDate"
                            label=""
                            rules={
                              !isAllAppliedOrReturned
                                ? { required: "Return Date is required." }
                                : {}
                            }
                          />
                        </Box>
                      </Box>
                    </Grid> */}

                  <Grid item xs={12} md={showOtherReturnOption ? 6 : 12}>
                    <FieldLabel label="Return Reason" required />
                    <Box sx={dropdownWrapSx(!!errors.returnReason)}>
                      <CustomDropdownField
                        name="returnReason"
                        control={control}
                        sortOptions={false}
                        options={returnReasonList}
                        onChangeSelect={onChangeReturnReasonList}
                        label=""
                        size="small"
                        rules={{
                          required: "Return Reason is required.",
                          validate: (value: string) =>
                            value.trim() !== "" || "Return Reason cannot be empty.",
                        }}
                      />
                    </Box>
                  </Grid>

                  {showOtherReturnOption && (
                    <Grid item xs={12} md={6}>
                      <FieldLabel label="Enter the return reason" required />
                      <Box sx={inputFieldSx(!!errors.otherReturnReason)}>
                        <CustomTextField
                          controllerName="otherReturnReason"
                          label=""
                          size="small"
                          onChange={(e) =>
                            setValue("otherReturnReason", e.target.value)
                          }
                          control={control}
                          rules={{ required: "Return Reason is required." }}
                        />
                      </Box>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <FieldLabel label="Additional Context" />
                    <Box sx={inputFieldSx()}>
                      <CustomTextField 
                        controllerName="additionalContext"
                        control={control}
                        label=""
                        size="small"
                        multiline
                        rows={5}
                        placeholder="Please provide any additional context or request regarding this return here"
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            {/* Returned Items + Attachments + Confirm & Submit */}
            <Box sx={cardSx}>
              <Box sx={{ px: 2.8, pt: 1.8, pb: 2.8 }}>
                {/* CS-1426 - Start */}
                {isMobile ? (
                  <>
                    {/* Select All Checkbox for mobile view */}
                    <Box mb={1.5} display="flex" alignItems="center" gap={0.5}>
                      <CustomCheckbox
                        control={control}
                        controllerName="selectAll"
                        onChange={handleSelectAllCheckbox}
                        tooltipMessage="Select All"
                        tooltipPlacement="top"
                        rules={!isAllAppliedOrReturned ? { required: true } : {}}
                      />
                      <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color: mTokens.textPrimary }}>
                        Select All
                      </Typography>
                    </Box>
                    {/* Mobile view - render cards */}
                    {orderItemRow?.map((row) => renderOrderItemCard(row))}
                  </>
                ) : (
                  <>
                    {/* Desktop view - render bordered grid table */}
                    {/* CS-1426 - End */}
                    <Box sx={{ border: `1px solid ${mTokens.border}`, borderRadius: "12px", overflow: "hidden" }}>
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "56px 1fr 1fr 160px",
                          gap: 1,
                          px: 2,
                          py: 0.9,
                          alignItems: "center",
                          backgroundColor: mTokens.headerFooterBg,
                          borderBottom: `1px solid ${mTokens.border}`,
                        }}
                      >
                        <CustomCheckbox
                          control={control}
                          controllerName="selectAll"
                          onChange={handleSelectAllCheckbox}
                          tooltipMessage="Select All"
                          tooltipPlacement="top"
                          rules={!isAllAppliedOrReturned ? { required: true } : {}}
                        />
                        <Typography sx={colHeaderSx}>Ordered Size</Typography>
                        <Typography sx={colHeaderSx}>Serial Number</Typography>
                        <Typography sx={{ ...colHeaderSx, textAlign: "center" }}>Status</Typography>
                      </Box>
                      {orderItemRow?.map((row, index) => (
                        <Box
                          key={row.orderItemId}
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "56px 1fr 1fr 160px",
                            gap: 1,
                            px: 2,
                            py: 1.1,
                            alignItems: "center",
                            borderBottom: index < orderItemRow.length - 1 ? `1px dashed ${mTokens.border}` : "none",
                          }}
                        >
                          <CustomCheckbox
                            onChange={(e) => handleCheckboxChange(e, row)}
                            isDisabled={isCheckBoxDisable(row)}
                            control={control}
                            controllerName={`checkbox.order${row.orderItemId}`}
                            rules={!isAllAppliedOrReturned ? { required: true } : {}}
                          />
                          <Typography sx={{ ...colBodySx, color: mTokens.accent, fontWeight: 700 }}>
                            {row.size}
                          </Typography>
                          <Box sx={inputFieldSx()}>
                            <CustomTextField
                              controllerName={`serialNumbers.serialNumber${row.orderItemId}`}
                              control={control}
                              label=""
                              size="small"
                              placeholder="Serial Number"
                              //@ts-ignore
                              isDisabled={checkSerialNumberPresent(row)}
                              onChange={(e) => handleSerialNumberChange(e, row)}
                              onBlur={() => trigger(`serialNumbers.serialNumber${row.orderItemId}` as any)}
                              rules={{ maxLength: { value: 50, message: "Serial Number cannot exceed 50 characters" } }}
                            />
                          </Box>
                          <Typography sx={{ ...colBodySx, textAlign: "center" }}>
                            {orderItemStatus(row)}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </>
                )}

                <Box sx={{ mt: 2.5 }}>
                <Grid container spacing={2.5}>
                  <Grid item md={6} xs={12}>
                    <Box display="flex" alignItems="center" gap={0.8} mb={1.2}>
                      <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color: mTokens.textPrimary }}>
                        Upload Image of Product Packaging
                      </Typography>
                      <CustomHelpMessage
                        title="Help"
                        message="Show a clear image of the packaging. Be sure there are no markings made on the packaging prior to return, such as: any writing on or damage to the package." />
                    </Box>
                    <Dropzone
                      name="attachmentProductBoxPictures"
                      onFileChange={handleProductBoxPicturesChange}
                      control={control}
                      label=""
                      subLabel={{
                        textColor: colors.error[300],
                        text: (selectedRow.length === 0 || hasSerialNumberPresent(selectedRow)) && getValues("attachmentProductBoxPictures")?.length <= 0
                          ? <></>
                          : <span style={{ fontStyle: 'italic', fontSize: '14px' }}>(Not Required)</span>
                      }}
                      // rules={selectedRow.length === 0 || !hasSerialNumberPresent(selectedRow) ? undefined : { required: "Pictures of the box that contains the product(s) is required." }}
                      rules={{ required: "Pictures of the box that contains the product(s) is required." }}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <Box display="flex" alignItems="center" gap={0.8} mb={1.2}>
                      <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color: mTokens.textPrimary }}>
                        Upload Image of Barcode Sticker(s) [Optional]
                      </Typography>
                      <CustomHelpMessage
                        title="Help"
                        message="Take picture(s) of the Tissue ID barcode sticker(s) associated with the product(s) you'd like to return." />
                    </Box>
                    <Dropzone
                      name="attachmentBarcodeSticker"
                      onFileChange={handleFaceSheetChange}
                      control={control}
                      label=""
                      subLabel={{
                        textColor: colors.error[300],
                        text: (selectedRow.length === 0 || hasSerialNumberPresent(selectedRow)) && getValues("attachmentBarcodeSticker")?.length <= 0 
                          ? <></>
                          : <span style={{ fontStyle: 'italic', fontSize: '14px' }}>(Not Required)</span>
                      }}
                      rules={selectedRow.length === 0 || !hasSerialNumberPresent(selectedRow) ? undefined : { required: "Barcode Sticker Attachment is required." }}
                    />
                  </Grid>
                </Grid>
                </Box>

                {/*Task Start cs-549 */}
                {/* <Grid>
                    <Grid container display={"flex"} alignItems={"center"} flexDirection="row" wrap="nowrap">
                      <Grid item>
                        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                          Are you providing your shipping label?
                        </label>
                      </Grid>
                      <Grid item mt={-1}>
                        <CustomHelpMessage
                          title="Help"
                          message="If No, manufacture provided label will be requested." />
                      </Grid>
                    </Grid>  
              <Grid style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
              <CustomRadioButton
                       controllerName="shippingLabel"
                       control={control}
                       options={[
                       { value: "yes", label: "Yes" },
                       { value: "no", label: "No" },
               ]}
                        onChange={handleOptionChange}
                        value={selectedOption}
                        rules={!selectedOption ? { required: true } : {}}
                />
          </Grid>
    </Grid>
      {selectedOption === 'yes' && (
        <Grid container spacing={2} mb={2} mt={2} alignItems="flex">*/}
          {/* Carrier Field */}
          {/* <Grid item xs={6} md={4}>
            <CustomDropdownField
              name={`returnTrackingInfo.${"returnCarrier"}`}
              control={control}
              options={carrierOptions}
              label="Carrier"
              rules={{
                required:"Carrier is required."
              }}
            />
          </Grid> */}

          {/* Shipping Tracking Field */}
          {/* <Grid item xs={6} md={4}>
            <Box display="flex" alignItems="flex">
              <CustomTextField
                controllerName={`returnTrackingInfo.${"returnTracking"}`}
                label="Shipping Tracking #"
                control={control}
                rules={{
                  required: "Shipping Tracking is required.",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      )}*/}

     {/*Task end cs-549 */}

                <Box sx={{ mt: 2.5 }}>
                <Typography sx={{ fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 600, mb: 1.5 }}>
                  I confirm, to the best of my knowledge, that the following statements are true:
                </Typography>
                <Box display="flex" flexDirection="column" gap={0.5}>
                  <CustomCheckbox
                    id={"12"}
                    control={control}
                    controllerName={`productNotDamaged`}
                    label="Product returned has not been opened, tampered with, damaged or contaminated."
                    name="productNotDamaged"
                    rules={{
                      required:
                        "Please read and acknowledge the consent clauses to complete the return.",
                    }}
                  />
                  <CustomCheckbox
                    id={"12"}
                    control={control}
                    controllerName={`productNotTransfer`}
                    label="The product did not transfer ownership or location from the original recipient entity."
                    name="productNotTransfer"
                    rules={{
                      required:
                        "Please read and acknowledge the consent clauses to complete the return",
                    }}
                  />
                  <CustomCheckbox
                    id={"12"}
                    control={control}
                    controllerName={`productStoredInRecommendedEnv`}
                    label="The product was stored in the recommended environment as stated by the product manufacturer."
                    name="productStoredInRecommendedEnv"
                    rules={{
                      required:
                        "Please read and acknowledge the consent clauses to complete the return.",
                    }}
                  />
                </Box>

                {/*Task Start cs-549 */}
                {/* <Grid container spacing={2} mb={2}>
                  <Grid item md={9} xs={12}>
                    Signature
                    <SignaturePad
                      onSignatureChange={handleSignatureChange}
                      name="signature"
                      textName="name"
                      control={control}
                      validationRules={
                        !isAllAppliedOrReturned
                          ? signaturePadValidations
                          : undefined
                      }
                      setSignOutside={
                        userInfo &&
                        fullName(
                          null,
                          userInfo.firstName,
                          userInfo.middleName,
                          userInfo.lastName
                        )
                      }
                    />
                  </Grid>
                </Grid> */}
                {/*Task End cs-549 */}

                <Box
                  mt={2.5}
                  p={2}
                  sx={{
                    borderRadius: "12px",
                    border: `1px solid ${mTokens.border}`,
                    backgroundColor: mTokens.headerFooterBg,
                  }}
                >
                  <Typography sx={{ fontSize: "0.95rem", fontWeight: 700, color: mTokens.textPrimary, mb: 0.6 }}>
                    What happens next?
                  </Typography>
                  <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary }}>
                    Submission will result in return request to the manufacturer. Upon approval, you will be contacted by the V3 service team to receive your shipping label.
                  </Typography>
                </Box>

                {/* CS-1426 - Start */}
                <Box
                  display="flex"
                  flexDirection={{ xs: "column", sm: "row" }}
                  justifyContent={{ xs: "stretch", sm: "flex-end" }}
                  gap={1.2}
                  mt={2.5}
                >
                  <Button
                    type="submit"
                    color="success"
                    removeUpperCase
                    startIcon={<ClassOutlined />}
                    sx={{
                      ...primaryBtnSx,
                      minWidth: { sm: 160 },
                      backgroundColor: mTokens.accent,
                      boxShadow: "0 4px 18px rgba(20,184,166,.35)",
                      "& .MuiTypography-root": { color: "#ffffff !important" },
                      "& .MuiButton-startIcon": { color: "#ffffff" },
                    }}
                  >
                    Submit
                  </Button>
                  <Button
                    color="error"
                    variant="outlined"
                    removeUpperCase
                    startIcon={<Cancel />}
                    onClick={() => navigate(-1)}
                    sx={{
                      ...cancelBtnSx,
                      minWidth: { sm: 140 },
                      "& .MuiTypography-root": { color: `${mTokens.error} !important` },
                      "& .MuiButton-startIcon": { color: mTokens.error },
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
                {/* CS-1426 - End */}
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Right: order info */}
          <Box sx={{ ...cardSx, order: { xs: 1, md: 2 } }}>
            <SectionHeader icon={<PersonOutlined fontSize="small" />} title="Info" />
            <Box sx={{ px: 2.8, py: 1.5 }}>
              <InfoRow label="Patient" value={orderInfo?.patientName} />
              <InfoRow label="Product" value={`${orderInfo?.productName} (${orderInfo?.manufacturerName})`} />
              <InfoRow label="Order ID" value={orderInfo?.orderNumber} />
              <InfoRow label="Order Type" value={orderInfo?.orderType} />
              {/* CS-1141 - Start */}
              {/* <InfoRow label="PO #" value={orderInfo?.poNumber} /> */}
              {/* CS-1141 - End */}
            </Box>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default Returns;
